import React, { createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

// Map a canonical (Italian) path to its localized URL.
// Italian lives at the root; English is prefixed with /en.
export const localePath = (path, language) => {
  if (language === 'en') return path === '/' ? '/en' : `/en${path}`;
  return path || '/';
};

// Strip the /en prefix to get the canonical (Italian) base path.
export const basePathFromLocation = (pathname) => {
  if (pathname === '/en') return '/';
  if (pathname.startsWith('/en/')) return pathname.slice(3); // drop '/en'
  return pathname;
};

// Language is derived from the URL (the source of truth), so it's crawlable and
// shareable. Must be rendered inside <BrowserRouter>.
export const LanguageProvider = ({ children }) => {
  const location = useLocation();
  const language =
    location.pathname === '/en' || location.pathname.startsWith('/en/') ? 'en' : 'it';
  const basePath = basePathFromLocation(location.pathname);

  const value = {
    language,
    basePath,
    localePath: (path) => localePath(path, language),
  };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};
